import { SocialMediaDetails } from '@/modals/social-medial/social-media-details';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { ConfigService } from '@services/config.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.scss']
})
export class SocialMediaComponent implements OnInit {

  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private appService: AppService,
    private router: Router,
    protected configService: ConfigService,
  ) { }



  socialMediaLinks: SocialMediaDetails[] = []; // existing links from backend
  isUpdate = false;
  editingId: number | null = null;
  socialModel:boolean = false
    // api
    destroy$: Subject<boolean> = new Subject<boolean>();
    // country code
    selectedCountryCode: string = '+91'; // default country code
    // update Input
    updateInput: string = ''


  ngOnInit(): void {
    this.getSocialMediasLinks()
  }


  socialMediaForm = new UntypedFormGroup({
  socialMediaSeq: new UntypedFormControl(), // for edit/update
  name: new UntypedFormControl('', Validators.required), // platform name or user-defined
  link: new UntypedFormControl('', [Validators.required, Validators.pattern('https?://.+')]),
  websiteId: new UntypedFormControl(0, Validators.required),
  websiteName: new UntypedFormControl('', Validators.required),
  createdAt: new UntypedFormControl(0),
  createdBy: new UntypedFormControl(''),
  updatedAt: new UntypedFormControl(0),
  updatedBy: new UntypedFormControl(''),
  status: new UntypedFormControl('active'),

  // Optional: keep individual fields for UI convenience
  facebook: new UntypedFormControl('', Validators.pattern('https?://.+')),
  twitter: new UntypedFormControl('', Validators.pattern('https?://.+')),
  instagram: new UntypedFormControl('', Validators.pattern('https?://.+')),
  linkedin: new UntypedFormControl('', Validators.pattern('https?://.+')),
  whatsapp: new UntypedFormControl('', Validators.pattern('^[+0-9]{7,15}$'))
});


public socialMediaFormErrors = {
  facebook: '',
  twitter: '',
  instagram: '',
  linkedin: '',
  whatsapp: ''
};



socialMediaValidation() {
  const form = this.socialMediaForm;
  let hasError = false;

  // Reset previous errors
  Object.keys(this.socialMediaFormErrors).forEach(key => this.socialMediaFormErrors[key] = '');

  // Get all values
  const facebook = form.get('facebook')?.value?.trim();
  const twitter = form.get('twitter')?.value?.trim();
  const instagram = form.get('instagram')?.value?.trim();
  const linkedin = form.get('linkedin')?.value?.trim();
  const whatsapp = form.get('whatsapp')?.value?.trim();

  // Validate individual filled links
  if (facebook && !/^https?:\/\/.+/.test(facebook)) {
    this.socialMediaFormErrors.facebook = 'Please enter a valid Facebook URL.';
    form.get('facebook')?.markAsTouched();
    hasError = true;
  }

  if (twitter && !/^https?:\/\/.+/.test(twitter)) {
    this.socialMediaFormErrors.twitter = 'Please enter a valid Twitter URL.';
    form.get('twitter')?.markAsTouched();
    hasError = true;
  }

  if (instagram && !/^https?:\/\/.+/.test(instagram)) {
    this.socialMediaFormErrors.instagram = 'Please enter a valid Instagram URL.';
    form.get('instagram')?.markAsTouched();
    hasError = true;
  }

  if (linkedin && !/^https?:\/\/.+/.test(linkedin)) {
    this.socialMediaFormErrors.linkedin = 'Please enter a valid LinkedIn URL.';
    form.get('linkedin')?.markAsTouched();
    hasError = true;
  }

  if (whatsapp && !/^[+0-9]{7,15}$/.test(whatsapp)) {
    this.socialMediaFormErrors.whatsapp = 'Please enter a valid WhatsApp number.';
    form.get('whatsapp')?.markAsTouched();
    hasError = true;
  }

  // Check if at least one link is provided
  if (!hasError && !facebook && !twitter && !instagram && !linkedin && !whatsapp) {
    this.toastr.error('Please provide at least one social media link.');
    hasError = true;
  }

  // If no errors, form is valid
  if (!hasError) {
    console.log('Form value', form.value);
    this.getSocialMediaJson();
  }

}


getSocialMediaJson() {
  const form = this.socialMediaForm;
  const websiteId = Number(localStorage.getItem('selectedWebsiteId'));
  const websiteName = localStorage.getItem('selectedWebsiteName');

  const links: any[] = [];

  // Helper function for new record
  const pushNewLink = (name: string, value: string) => {
    if (value?.trim()) {
      links.push({
        name,
        link: value,
        websiteId,
        websiteName,
      });
    }
  };

  // Helper function for update
  const pushUpdateLink = (seq: number, name: string, value: string) => {
    if (value?.trim()) {
      links.push({
        socialMediaSeq: seq,
        name,
        link: value,
        websiteId,
        websiteName,
        status: 'Active',
      });
    }
  };

  if (!this.isUpdate) {
    // Insert mode
    pushNewLink('Facebook', form.get('facebook')?.value);
    pushNewLink('Twitter', form.get('twitter')?.value);
    pushNewLink('Instagram', form.get('instagram')?.value);
    pushNewLink('LinkedIn', form.get('linkedin')?.value);
    pushNewLink('WhatsApp', form.get('whatsapp')?.value);

    console.log('📥 Insert JSON:', links);
    this.saveLinks(links);

  } else {
    // Update mode -> only push based on updateInput
    const seq = form.get('socialMediaSeq')?.value;

    switch (this.updateInput) {
      case 'Facebook':
        pushUpdateLink(seq, 'Facebook', form.get('facebook')?.value);
        break;
      case 'Twitter':
        pushUpdateLink(seq, 'Twitter', form.get('twitter')?.value);
        break;
      case 'Instagram':
        pushUpdateLink(seq, 'Instagram', form.get('instagram')?.value);
        break;
      case 'LinkedIn':
        pushUpdateLink(seq, 'LinkedIn', form.get('linkedin')?.value);
        break;
      case 'WhatsApp':
        pushUpdateLink(seq, 'WhatsApp', form.get('whatsapp')?.value);
        break;
      default:
        console.warn('⚠️ No matching platform for updateInput:', this.updateInput);
        break;
    }

    console.log('✏️ Update JSON:', links);
    this.updateLinks(links);
  }
}







  

  saveLinks(links: any) {
    this.spinner.show();
     this.appService.addSocialMediaLinks(links)
       .pipe(takeUntil(this.destroy$))
       .subscribe({
         next: (data) => {
           console.log('Testimonial saved:', data);
           this.spinner.hide();
           this.toastr.success('Testimonial saved successfully!');
           this.socialModel = false;
           this.socialMediaForm.reset()
           this.getSocialMediasLinks()
         },
         error: (error) => {
           console.error('Error:', error);
           this.spinner.hide();
           const msg = error?.error?.msg || 'Something went wrong, please try again';
           this.toastr.error(msg);
         }
       });

    this.socialMediaForm.reset();
    this.isUpdate = false;
    this.editingId = null;
  }

  getSocialMediasLinks() {
 this.spinner.show();
  this.appService.getSocialMediaLinks()
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (data) => {
        console.log("social media", data)
        this.socialMediaLinks = data.sort((a,b)=> b.socialMediaSeq - a.socialMediaSeq)
        this.spinner.hide();
      },
      error: (error) => {
        console.error('Error:', error);
        this.spinner.hide();
        const msg = error?.error?.msg || 'Something went wrong, please try again';
        this.toastr.error(msg);
      }
    });
  }


    updateLinks(links: any) {
      console.log('Link Updated:', links);
    this.spinner.show();
     this.appService.updateSocialMediaLinks(links)
       .pipe(takeUntil(this.destroy$))
       .subscribe({
         next: (data) => {
           console.log('Link Updated:', data);
           this.spinner.hide();
           this.toastr.success('Link Updated successfully!');
           this.socialModel = false;
           this.socialMediaForm.reset()
           this.getSocialMediasLinks()
         },
         error: (error) => {
           console.error('Error:', error);
           this.spinner.hide();
           const msg = error?.error?.msg || 'Something went wrong, please try again';
           this.toastr.error(msg);
         }
       });

    this.socialMediaForm.reset();
    this.isUpdate = false;
    this.editingId = null;
  }

  toggleStatus(item: any, event: any) {
     
   if(event.target.checked) {
    const payload = {
      socialMediaSeq:item,
      status: 'Active'
    }
     this.updateStatus(payload)
    console.log("checked or Active",payload )
   } else {
     const payload = {
      socialMediaSeq:item,
      status: 'InActive'
    }
    this.updateStatus(payload)
    console.log("Un-checked or Inactive",payload )
   }
  }

  updateStatus(payload) {
    this.spinner.show();
    this.appService
      .updateSocialMediaStatus(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          console.log("status", data);
          this.spinner.hide()
         this.toastr.success (" Status Updated successfully");
        },
        (error: any) => {
          this.spinner.hide();
          this.toastr.error(
            error.error.message || "Something went wrong,please try again..."
          );
        }
      );
  }




editLink(item: any) {
  this.updateInput = item.name 
  console.log("clicked value", item)
  // Map the item to form fields explicitly
  this.socialMediaForm.patchValue({
    socialMediaSeq: item.socialMediaSeq || item.id || 0,
    name: item.name || '',
    link: item.link || '',
    websiteId: item.websiteId || 0,
    websiteName: item.websiteName || '',
    facebook: item.name === 'Facebook' ? item.link : '',
    twitter: item.name === 'Twitter' ? item.link : '',
    instagram: item.name === 'Instagram' ? item.link : '',
    linkedin: item.name === 'LinkedIn' ? item.link : '',
    whatsapp: item.name === 'WhatsApp' ? item.link : '',
    status: item.status || 'active'
  });

  console.log("clicked form value", this.socialMediaForm.value)

  this.isUpdate = true;
  this.editingId = item.socialMediaSeq || item.id;
  this.socialModel = true;
}


  deleteLink(id: number) {
     this.spinner.show();
  this.appService.deleteSocialMediaLinks(id)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (data) => {
        this.toastr.success('Link Deleted successfully!');
        this.spinner.hide()
        this.getSocialMediasLinks()
      },
      error: (error) => {
        console.error('Error:', error);
        this.spinner.hide();
        const msg = error?.error?.msg || 'Something went wrong, please try again';
        this.toastr.error(msg);
      }
    });
  }


closeModel() {
  // Ensure updateInput has a default value if empty or whitespace
  this.updateInput = '';
  this.socialMediaForm.reset()
  // Close the modal
  this.socialModel = false;
}



//   getFullWhatsappNumber(): string {
//   const number = this.socialMediaForm.get('whatsapp')?.value || '';
//   return this.selectedCountryCode + number;
// }



}
